import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { ParametersItem } from 'ducks/types/store-types';

const initialState: ParametersItem[] = [];

const parametersSlice = createSlice({
  name: Slices.PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
});

export const { clearParameters } = parametersSlice.actions;

export default parametersSlice.reducer;
